module.exports = __webpack_public_path__ + "img/logo.9258955b.png";